import type { ManufacturingUnitDetail } from "@/lib/manufacturing/productionClient";

export function BuildPipelineUnitPlantPacket(props: {
  packet: ManufacturingUnitDetail["plant_packet"];
  busy?: boolean;
}) {
  const rows = props.packet;
  return (
    <section>
      <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
        Plant packet
      </h3>
      <p className="mb-2 text-[11px] text-gray-500">
        What this manufacturer asked the dealer to send. Floor plan can be a file or an image URL.
      </p>
      {props.busy ? (
        <p className="text-xs text-gray-500">Loading…</p>
      ) : rows.length === 0 ? (
        <p className="text-xs text-gray-500">No plant packet on this unit yet.</p>
      ) : (
        <ul className="space-y-1.5 text-xs">
          {rows.map((row) => (
            <li
              key={row.item_key}
              className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-gray-200 px-2 py-1.5 dark:border-zinc-700"
            >
              <span className="font-medium text-gray-800 dark:text-zinc-100">{row.label}</span>
              <span className="text-gray-500">{row.status}</span>
              {row.evidence_url ? (
                <a
                  href={row.evidence_url}
                  target="_blank"
                  rel="noreferrer"
                  className="text-indigo-700 underline dark:text-indigo-300"
                >
                  Open
                </a>
              ) : null}
              {row.notes ? (
                <p className="w-full text-[11px] text-gray-600 dark:text-zinc-400">{row.notes}</p>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
